<mat-card>
  <mat-card-title>
    {{ 'DOCUMENTS_MODAL.TITLE' | translate }}
  </mat-card-title>
  <mat-card-content class="flex flex-col gap-[10px]">
    <div>
      {{ 'DOCUMENTS_MODAL.UPDATED_DOCUMENTS_INFORMATION' | translate }}
    </div>
    <form
      [formGroup]="documentForm"
      *ngIf="documentsStore.updatedDocuments$ | async as updatedDocuments$"
      class="flex flex-col gap-[5px]"
    >
      <div formArrayName="documents" *ngFor="let document of getControls(); let i = index">
        <mat-checkbox [formControlName]="i">
          {{ 'DOCUMENTS_MODAL.AGREEMENT_TEXT' | translate }}
          <a
            [href]="updatedDocuments$[i].link"
            gtm="onRedirect"
            gtmAction="Updated document"
            gtmCategory="documentUpdate"
            gtmLabel="{{ updatedDocuments$[i].link }}"
            target="_blank"
          >
            {{ updatedDocuments$[i].title }}</a
          >
        </mat-checkbox>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions align="end" class="flex flex-row gap-[10px]">
    <button
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="documentsUpdateModal"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="documentForm?.invalid"
      gtm="onConfirm"
      gtmCategory="documentsUpdateModal"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.ACCEPT' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
